import { AlphaFIcon } from './AlphaFIcon';

/**
 * author: GreenTurtwig
 * id 6E5FB32C-27B6-4ECE-8F88-65D8E29D1CD8
 * name alpha-f
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-f.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetFIcon = AlphaFIcon;
export default AlphabetFIcon